import { render, staticRenderFns } from "./BankAccountsDetail.vue?vue&type=template&id=4b028ff6&"
import script from "./BankAccountsDetail.vue?vue&type=script&lang=js&"
export * from "./BankAccountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports